
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E95843","d":"M42.76 39.914c-1.63 1.191-3.89 1.191-5.487 0L10.1 19.768c-.034.16-.1.29-.1.45v38.749c0 1.77 1.497 3.218 3.326 3.218h53.348c1.83 0 3.326-1.448 3.326-3.218v-38.78c0-.162-.067-.29-.1-.451L42.76 39.914z"}}),_c('path',{attrs:{"fill":"#F96481","d":"M42.76 39.914l27.173-20.146A3.257 3.257 0 0066.707 17H13.326a3.256 3.256 0 00-3.226 2.768l27.173 20.146c1.596 1.223 3.858 1.223 5.487 0z"}}),_c('path',{attrs:{"fill":"#F6CFC9","d":"M42.76 39.914l27.173-20.146A3.257 3.257 0 0066.707 17H13.326a3.256 3.256 0 00-3.226 2.768l27.173 20.146c1.596 1.223 3.858 1.223 5.487 0z"}})])
          )
        }
      }
    